import { useMicroSkillsQuery } from '@/modules/skills/graphql/queries/generated/microSkills';
import { GeneratedByEnum, Maybe, SkillTypeEnum } from '@/types/schema';

interface Params {
  ids?: Maybe<string[]>;
  filteredSkillIds?: string[];
  searchText?: Maybe<string>;
  pause?: boolean;
  orgRoleIds?: string[];
}

const useMicroSkills = ({
  ids = [],
  pause,
  searchText = '',
  filteredSkillIds = [],
  orgRoleIds,
}: Params) => {
  const [{ data, fetching, error }] = useMicroSkillsQuery({
    variables: {
      filters: {
        ids,
        name: searchText,
        generatedBy: GeneratedByEnum.All,
        visibleInListing: true,
        types: [SkillTypeEnum.Ability],
        orgRoleIds,
      },
      first: -1,
    },
    pause,
  });

  const skills =
    data?.skills.edges
      ?.map(({ node }) => node)
      .filter((node) => !filteredSkillIds.includes(node.id)) || [];

  return { skills, fetching, error };
};
export type UseMicroSkillsReturn = ReturnType<typeof useMicroSkills>;
export type SkillsType = UseMicroSkillsReturn['skills'];

export default useMicroSkills;
